import React from 'react'
import * as styles from './../Footer.module.scss'
import locations from './../../../data/locations.json'
import LocationTab from './LocationTab'

const LocationsList = () => {
  const locationTabs = locations.map((location) => {
    return <LocationTab key={location.Name} location={location} />
  })

  let key = 0
  while (locationTabs.length % 3 !== 0) {
    key++
    locationTabs.push(
      <article key={key} className={styles.placeholderLocation}></article>
    )
  }
  return <>{locationTabs}</>
}

export default LocationsList
